export const pronounOptions = [
  { value: "She/Her", label: "She/Her" },
  { value: "He/Him", label: "He/Him" },
  { value: "They/Them", label: "They/Them" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];